import { connect } from 'react-redux'
import Menu from '../components/MainMenu'
import {getProductCodes, getAdminInfo} from '../actions/index'


const mapStateToProps = state => {
    return {
        isLoggedIn : state.auth.isLoggedIn,
        userName: state.auth.username,
        isAdmin: state.auth.adminInfo === 1
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
      // Refetch data that only lives in redux state, so it survives a page
      // refresh (the store is rebuilt empty on reload). Swallow errors here so
      // an expired token does not surface as an unhandled promise rejection.
      loadSession: () => {
          Promise.resolve(dispatch(getProductCodes())).catch(() => {})
          Promise.resolve(dispatch(getAdminInfo())).catch(() => {})
      }
  }


};

export default connect(
    mapStateToProps,
    mapDispatchToProps

)(Menu);
